/**
 * Regular expression match.
 */
export interface RegexMatch {
  match: string;
  index: number;
  groups: string[];
}

/**
 * Regular expression type.
 */
export enum RegexType {
  match = 'Match',
  group = 'Group'
}
